import { Box } from "@mui/material";
import { customStyles } from "./index.styles";
import HomeSectionText from "./HomeSectionText";
import { WhyUsSection } from "./WhyUsSection";

interface Props {
  id: string;
}

const headerImage = `${process.env.PUBLIC_URL}/images/header2.png`;
const headerImageSmall = `${process.env.PUBLIC_URL}/images/header3.png`;

const HomeSection = ({ id }: Props) => (
  <Box id={id}>
    <Box
      sx={[
        customStyles.mainBox,
        {
          backgroundImage: {
            xs: `url(${headerImageSmall})`,
            md: `url(${headerImage})`,
          },
        },
      ]}
    />

    {/* Blur overlay for smaller screens */}
    <Box
      sx={{
        display: { xs: "block", md: "none" },
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        pointerEvents: "none",
        zIndex: 0,
      }}
    />

    {/* Gradient overlay from bottom to top */}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        background: "linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 50%)",
        pointerEvents: "none",
        zIndex: 0,
      }}
    />

    <Box
      sx={{
        top: 0,
        height: "100vh",
        background: "white",
        opacity: 0,
        width: "99.5vw",
        position: "absolute",
      }}
    />

    <HomeSectionText />

    <WhyUsSection />
  </Box>
);

export default HomeSection;
